import { Checkbox, Collapse, Select, Typography } from 'antd';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BRAND_COLORS } from '../../../../constants/styles';
import { DateRangeType } from '../../../../types/phlebotomist-dashboard';
import {
  IRecruiterViewOptions,
  RECRUITER_DATE_RANGE_OPTIONS,
  RECRUITER_VIEW_OPTION_LABELS,
} from '../../config/viewOptions';

const { Text } = Typography;

export interface IViewOptionsAccordionProps {
  viewOptions: IRecruiterViewOptions;
  defaultDateRange: DateRangeType;
  onViewOptionChange: (
    key: keyof IRecruiterViewOptions,
    checked: boolean
  ) => void;
  onDefaultDateRangeChange: (value: DateRangeType) => void;
}

export const ViewOptionsAccordion: FC<IViewOptionsAccordionProps> = ({
  viewOptions,
  defaultDateRange,
  onViewOptionChange,
  onDefaultDateRangeChange,
}) => {
  const { t } = useTranslation('dashboard.RecruiterDashboard.viewOptions');

  const translatedDateRangeOptions = useMemo(
    () =>
      RECRUITER_DATE_RANGE_OPTIONS.map((group, idx) => ({
        label: t(
          idx === 0 ? 'dateRangeGroups.rolling' : 'dateRangeGroups.calendar'
        ),
        options: group.options.map((opt) => ({
          value: opt.value,
          label: t(`dateRangeOptionLabels.${opt.value}`),
        })),
      })),
    [t]
  );

  return (
    <>
      <Collapse
        bordered={false}
        style={{ background: 'transparent' }}
        className="recruiter-visibility-collapse"
      >
        <Collapse.Panel
          key="visibility"
          header={
            <Text strong style={{ color: BRAND_COLORS.primary.deepNavy }}>
              {t('header')}
            </Text>
          }
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginBottom: 10,
            }}
          >
            <Text style={{ fontSize: 12, color: '#6e7a8a', flexShrink: 0 }}>
              {t('defaultDateRange')}
            </Text>
            <Select
              size="small"
              value={defaultDateRange}
              onChange={onDefaultDateRangeChange}
              style={{ width: 200 }}
              options={translatedDateRangeOptions}
            />
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 24px' }}>
            {RECRUITER_VIEW_OPTION_LABELS.map(({ key }) => (
              <Checkbox
                key={key}
                checked={viewOptions[key]}
                onChange={(e) => onViewOptionChange(key, e.target.checked)}
              >
                {t(`optionLabels.${key}`)}
              </Checkbox>
            ))}
          </div>
        </Collapse.Panel>
      </Collapse>
      <style>{`
        .recruiter-visibility-collapse .ant-collapse-header {
          padding: 4px 0 !important;
        }
        .recruiter-visibility-collapse .ant-collapse-content-box {
          padding: 8px 0 4px 0 !important;
        }
      `}</style>
    </>
  );
};
